<template lang="pug">
header.header(:class="$route.meta.headerClass")
  router-link.header__link(to="/")
    img.header__logo(:src="require('../assets/logo.png')" :class="$route.meta.headerClass")
</template>

<script>
// import debug from 'debug'

// const log = debug('component:AppHeader')

export default {
  name: 'AppHeader',
}
</script>

<style lang="scss" scoped>
.header {
  padding: 6.25rem 2rem 1.875rem;
  margin: 0 auto;

  &.light {
    padding: 0;
  }

  &__logo {
    width: 18.75rem;
    display: block;
    margin-left: auto;
    margin-right: auto;

    &.light {
      display: none;
    }
  }

  @media (max-width: 640px) {
    padding: 3rem 2rem 1.875rem;

    &__logo {
      width: 12.5rem;
    }
  }
}
</style>
